import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { logo2Icon } from "../../Assets";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { showNotificationWithTimeout } from "../../Redux/actions/toastActions";
import { removeUnderScore } from "../../helpers";
import {
  changeIsRegistered,
  saveForgotDetails,
  saveLoginDetails,
} from "../../Redux/actions";

const schema = yup
  .object({
    email: yup.string().required().max(255),
    password: yup.string().required().min(8).max(255),
  })
  .required();
const forgotSchema = yup
  .object({
    email: yup.string().required().max(255),
  })
  .required();

const Login = () => {
  const { is_registered } = useSelector((state) => state.authReducer);
  const { toastMsgs } = useSelector((state) => state.toastReducer);
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  const {
    register: forgotRegister,
    formState: { errors: forgotErrors },
    handleSubmit: forgotHandleSubmit,
    control: forgotControl,
    setValue: forgotSetValue,
  } = useForm({
    resolver: yupResolver(forgotSchema),
    mode: "all",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    if (is_registered) dispatch(changeIsRegistered(false));
  }, [is_registered]);

  useEffect(() => {
    checkToastMsg();
  }, [toastMsgs]);

  const [showLogin, setShowLogin] = useState(true);

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const checkToastMsg = () => {
    if (toastMsgs.length > 0) {
      const findSuccessInx = toastMsgs.findIndex((p) => p.msgtype == "success");
      if (findSuccessInx > -1) {
        setSuccessMsg(toastMsgs[findSuccessInx].text);
      } else {
        setSuccessMsg("");
      }
      const findErrorInx = toastMsgs.findIndex((p) => p.msgtype == "error");
      if (findErrorInx > -1) {
        setErrorMsg(toastMsgs[findErrorInx].text);
      } else {
        setErrorMsg("");
      }
    } else {
      setSuccessMsg("");
      setErrorMsg("");
    }
  };

  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
  });

  const changeInputHandler = (input, val) => {
    setValue(input, val);
    setLoginForm((prevState) => ({ ...prevState, [input]: val }));
  };

  const onLoginSubmit = (data) => {
    console.log("sub_data:", data);
    dispatch(saveLoginDetails(data));
  };

  const onForgotSubmit = (data) => {
    console.log("forgot_sub_data:", data);
    dispatch(saveForgotDetails(data));
  };

  const showToastMsg = () => {
    return (
      <React.Fragment>
        <Zoom opposite when={successMsg !== ""}>
          <>
            <div
              id="flashMessage"
              className={`${successMsg !== "" ? "message" : ""}`}
            >
              {successMsg}
            </div>
          </>
        </Zoom>
        <Zoom opposite collapse when={errorMsg !== ""}>
          <>
            <div id="flashMessage" className="new_flash_message_error">
              <p>{errorMsg}</p>
            </div>
          </>
        </Zoom>
      </React.Fragment>
    );
  };

  return (
    <>
      <div className="logo_container">
        <a href="/">
          <img src={logo2Icon} />
        </a>
      </div>
      <Fade opposite collapse when={showLogin}>
        <div className={`login-container`}>
          {showToastMsg()}
          <div className="login-header bordered">
            <h4>Sign in</h4>
          </div>
          <form id="UserLoginForm" onSubmit={handleSubmit(onLoginSubmit)}>
            <div className="login-field">
              <input
                {...register("email")}
                type="email"
                autoComplete="new-password"
                placeholder="Email"
                value={loginForm?.account_name}
                onChange={(e) => {
                  changeInputHandler("account_name", e?.target?.value);
                }}
              />
              {errors?.email && (
                <label className="error">
                  {removeUnderScore(errors.email?.message)}
                </label>
              )}
            </div>
            <div className="login-field">
              <input
                {...register("password")}
                autoComplete="new-password"
                id="password"
                type="password"
                value={loginForm?.password}
                onChange={(e) => {
                  changeInputHandler("password", e?.target?.value);
                }}
              />
              {errors?.password && (
                <label className="error">
                  {removeUnderScore(errors.password?.message)}
                </label>
              )}
            </div>
            <div className="login-button clearfix">
              <button type="submit" className="pull-right btn btn-large blue">
                SIGN IN{" "}
              </button>
            </div>
            <div className="forgot-password float_left">
              <a
                className="link"
                onClick={() => setShowLogin(false)}
                id="showforgotdiv"
              >
                Forgot password?
              </a>
            </div>
            <div className="forgot-password float_right">
              <a className="link" onClick={() => history.push("/register")}>
                Sign Up
              </a>
            </div>
          </form>
        </div>
      </Fade>
      <Fade opposite collapse when={!showLogin}>
        <div className={`login-container show_forgot_password`}>
          {showToastMsg()}
          <div className="login-header bordered">
            <h4 id="changeheading">Forgot Password</h4>
          </div>
          {/* <p id="success_msg" style="color:green;text-align: center"></p>
        <p id="showerror" style="color:red;text-align: center"></p> */}
          <form onSubmit={forgotHandleSubmit(onForgotSubmit)}>
            <div id="forgotnext1">
              <div className="login-field">
                <input
                  {...forgotRegister("email")}
                  type="text"
                  id="checkemail"
                  className="span12"
                  placeholder="example@domain.com"
                />
                {forgotErrors?.email && (
                  <label className="error">
                    {removeUnderScore(forgotErrors.email?.message)}
                  </label>
                )}
              </div>
              <div className="login-button clearfix">
                <button
                  type="submit"
                  className="pull-right btn btn-large blue"
                  id="goNext"
                >
                  Next{" "}
                </button>
              </div>
            </div>
          </form>
          <div className="forgot-password float_left">
            <a onClick={() => setShowLogin(true)} id="showforgotdiv">
              Sign In
            </a>
          </div>
        </div>
      </Fade>
    </>
  );
};
export default Login;
